import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Center, Divider } from "native-base";
import { useNavigate } from "@madmedical/routing";
import { useTranslation } from "@madmedical/i18n";
import InsulinMeasurementsTable from "../../organisms/InsulinMeasurementsTable";
import useResponsive from "../../util/useResponsive";
import ListHeader from "../../molecules/ListHeader";
import Paper from "../../atoms/Paper";
import ButtonLink from "../../atoms/ButtonLink";
import DashboardInsulinMeasurementContentMobile from "./DashboardInsulinMeasurementContentMobile";
const DesktopLayout = ({ section }) => {
    const navigate = useNavigate();
    if (!section) {
        return null;
    }
    const handlePress = () => {
        navigate("insulin", {});
    };
    return (_jsx(_Fragment, { children: _jsx(Box, Object.assign({ width: "full", px: 6, py: 4 }, { children: _jsx(InsulinMeasurementsTable, { data: section, pressLink: handlePress }) }), `measurement-table-section`) }));
};
const DashboardInsulinMeasurementList = ({ data, isPatient = true }) => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const todaysItems = data === null || data === void 0 ? void 0 : data.filter((item) => {
        const administeredAt = new Date(item.administeredAt);
        const today = new Date();
        const time1 = administeredAt.getTime();
        const time2 = today.getTime();
        const diff = Math.abs(time1 - time2);
        const hours = Math.floor(diff / (1000 * 60 * 60));
        return hours <= 24;
    }).slice(0, 5);
    return isSmallScreen ? (_jsxs(_Fragment, { children: [_jsx(ListHeader, { title: isPatient ? "Legfrissebb inzulin beadások" : "Inzulin napló", borderBottomWidth: 0, px: 0 }), _jsxs(Paper, Object.assign({ mb: 3 }, { children: [_jsx(DashboardInsulinMeasurementContentMobile, { sections: todaysItems.slice(0, 3) }), _jsx(Center, Object.assign({ my: 4, width: "full" }, { children: _jsx(ButtonLink, Object.assign({ size: "sm", variant: "outlined", route: "insulin_administrations", params: {} }, { children: t("viewAll") })) }))] }))] })) : (_jsx(Box, Object.assign({ marginBottom: 4 }, { children: _jsxs(Paper, Object.assign({ borderTopLeftRadius: 0, borderTopRightRadius: 0, width: "full", bgColor: "white" }, { children: [_jsx(ListHeader, { title: isPatient
                        ? "Legfrissebb inzulin beadások"
                        : "Inzulin napló", borderBottomWidth: 1, px: 8, variant: "inverted" }), _jsx(Divider, { _light: {
                        bg: "gray.100",
                    } }), _jsx(DesktopLayout, { section: todaysItems }), _jsx(Center, Object.assign({ my: 4, width: "full" }, { children: _jsx(ButtonLink, Object.assign({ size: "sm", variant: "outlined", route: "insulin_administrations", params: {} }, { children: t("viewAll") })) }))] })) })));
};
export default DashboardInsulinMeasurementList;
